/* angular:styles/component:css;2c22e460b155c6999479efcda5bbf68b317dd8a086f2fe29802d3bdc12a46c90;/src/src/app/shared/components/formly/formly-select/formly-select.ts */
:host {
  width: 100%;
}
ion-item.custom-select-item::part(inner) {
  padding-right: 0 !important;
}
.ion-modal-fullscreen {
  --width: 100%;
  --max-width: 100%;
}
ion-select {
  color: inherit !important;
}
ion-select::part(label) {
  white-space: pre-wrap !important;
  font-size: initial !important;
  flex: 1;
  min-width: 30%;
  max-width: 50%;
  margin-inline-end: 0 !important;
}
.custom-ion-alert {
  color: var(--ion-color-text) !important;
}
.custom-select-item {
  --inner-padding-end: 0;
  display: flex;
  align-items: center;
}
.custom-select-item ion-label {
  margin: 0;
  flex: 0 0 auto;
  min-width: 30%;
  max-width: 50%;
  white-space: pre-wrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom-select-item .select-value-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.25rem;
  min-width: 0;
}
.custom-select-item ion-text {
  flex: 1;
  font-size: 0.875rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--ion-text-color);
}
.custom-select-item ion-icon {
  flex-shrink: 0;
}
/*# sourceMappingURL=formly-select.css.map */
